const LANG = __language;

const monthStrings = {
    ru: ['Янв', 'Фев', 'Мар', 'Апр', 'Мая', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    uk: ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру'],
} as const;

export function tjsMonths(): string[] {
    return (monthStrings[LANG] ?? monthStrings['ru']) as unknown as string[];
}

const strings = {
    ru: {
        // SlimSelect / search
        slim_search: 'Искать',
        slim_nothing: 'Ничего не найдено',
        slim_placeholder: 'Поиск...',
        // Comments sort
        sort_label: 'Сортировать:',
        sort_new_first: 'сначала новые',
        sort_old_first: 'сначала старые',
        sort_by_rating: 'по рейтингу',
        load_comments: 'Загрузить комментарии',
        comment_placeholder: 'Текст комментария',
        // Filter labels
        filter_genres: 'Выбрать жанры',
        filter_genres_ph: 'По каким жанрам искать',
        filter_exclude_genres: 'Исключить жанры',
        filter_exclude_genres_ph: 'Какие жанры исключить',
        filter_type: 'Тип аниме',
        filter_type_ph: 'Какой тип аниме искать',
        filter_status: 'Статус аниме',
        filter_year: 'Год',
        filter_year_from: 'от',
        filter_year_to: 'до',
        filter_season: 'Сезон',
        filter_episodes: 'Количество серий',
        filter_ep_tooltip: 'В онгоингах и анонсах не всегда указано',
        filter_age: 'Возрастной рейтинг',
        filter_sort: 'Сортировать по',
        filter_search: 'Искать',
        filter_random: 'Случайное аниме по фильтру',
        filter_expand: 'Расширить фильтр',
        filter_asc: 'По возрастанию',
        filter_desc: 'По убыванию',
        // Sort options
        sort_relevance: 'Релевантности',
        sort_title_az: 'Названию (А-Я)',
        sort_year: 'Дате выхода',
        sort_rating: 'Рейтингу',
        sort_votes: 'Голосам',
        sort_views: 'Просмотрам',
        // Footer
        footer_resources: 'НАШИ РЕСУРСЫ',
        footer_site_info: 'ИНФОРМАЦИЯ О САЙТЕ',
        footer_support: 'ТЕХНИЧЕСКАЯ ПОДДЕРЖКА И ПОМОЩЬ',
        footer_disclaimer: 'Все видео на сайте предоставлены только для ознакомления.',
        footer_about: 'О САЙТЕ',
        footer_rules: 'ПРАВИЛА САЙТА',
        footer_privacy: 'ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ',
        footer_rightholders: 'ИНФОРМАЦИЯ ДЛЯ ПРАВООБЛАДАТЕЛЕЙ',
        footer_api: 'API САЙТА',
        footer_chat: 'ЧАТ С ПОДДЕРЖКОЙ',
        footer_dev: 'КАНАЛ РАЗРАБОТКИ В ТЕЛЕГРАМ',
        footer_email: 'Почта для сотрудничества:',
        footer_tg: 'Телеграм поддержки для пользователей:',
        footer_rights: 'Все права защищены.',
        footer_new: 'Новый дизайн сайта',
        time_at: ' в ',
        ep_short: 'эп.',
        nothing_found: 'Ничего не найдено.',
        nothing_found_shrug: 'Ничего не найдено ¯\\_(ツ)_/¯',
        search_try_query: 'Попробуйте изменить поисковой запрос',
        search_try_filter: 'Попробуйте изменить фильтр.',
        search_or: 'или',
        search_google: 'загуглить',
        search_google_suffix: ' аниме',
        search_live_nothing: 'Ничего не найдено. Попробуйте указать другое название.',
        search_open_all: 'Открыть все результаты',
        loading: 'Загрузка',
        show_more: 'Показать ещё',
        tg_support: "//YummyAnime_support.t.me/"
    },
    en: {
        slim_search: 'Search',
        slim_nothing: 'Nothing found',
        slim_placeholder: 'Search...',
        sort_label: 'Sort by:',
        sort_new_first: 'newest first',
        sort_old_first: 'oldest first',
        sort_by_rating: 'by rating',
        load_comments: 'Load comments',
        comment_placeholder: 'Comment text',
        filter_genres: 'Select genres',
        filter_genres_ph: 'Search by genres',
        filter_exclude_genres: 'Exclude genres',
        filter_exclude_genres_ph: 'Genres to exclude',
        filter_type: 'Anime type',
        filter_type_ph: 'Search by type',
        filter_status: 'Anime status',
        filter_year: 'Year',
        filter_year_from: 'from',
        filter_year_to: 'to',
        filter_season: 'Season',
        filter_episodes: 'Number of episodes',
        filter_ep_tooltip: 'Not always specified for ongoing and announced anime',
        filter_age: 'Age rating',
        filter_sort: 'Sort by',
        filter_search: 'Search',
        filter_random: 'Random anime by filter',
        filter_expand: 'Expand filter',
        filter_asc: 'Ascending',
        filter_desc: 'Descending',
        sort_relevance: 'Relevance',
        sort_title_az: 'Title (A-Z)',
        sort_year: 'Release date',
        sort_rating: 'Rating',
        sort_votes: 'Votes',
        sort_views: 'Views',
        footer_resources: 'OUR RESOURCES',
        footer_site_info: 'ABOUT THE SITE',
        footer_support: 'TECHNICAL SUPPORT & HELP',
        footer_disclaimer: 'All videos on the site are provided for viewing purposes only.',
        footer_about: 'ABOUT',
        footer_rules: 'SITE RULES',
        footer_privacy: 'PRIVACY POLICY',
        footer_rightholders: 'COPYRIGHT HOLDERS INFO',
        footer_api: 'SITE API',
        footer_chat: 'SUPPORT CHAT',
        footer_dev: 'DEV CHANNEL ON TELEGRAM',
        footer_email: 'Partnership email:',
        footer_tg: 'Telegram support for users:',
        footer_rights: 'All rights reserved.',
        footer_new: 'New site design',
        time_at: ' at ',
        ep_short: 'ep.',
        nothing_found: 'Nothing found.',
        nothing_found_shrug: 'Nothing found ¯\\_(ツ)_/¯',
        search_try_query: 'Try changing your search query',
        search_try_filter: 'Try changing the filter.',
        search_or: 'or',
        search_google: 'google it',
        search_google_suffix: '',
        search_live_nothing: 'Nothing found. Try a different title.',
        search_open_all: 'Show all results',
        loading: 'Loading',
        show_more: 'Show more',
        tg_support: "//YummyAnime_support_en.t.me/"
    },
    uk: {
        slim_search: 'Шукати',
        slim_nothing: 'Нічого не знайдено',
        slim_placeholder: 'Пошук...',
        sort_label: 'Сортувати:',
        sort_new_first: 'спочатку нові',
        sort_old_first: 'спочатку старі',
        sort_by_rating: 'за рейтингом',
        load_comments: 'Завантажити коментарі',
        comment_placeholder: 'Текст коментаря',
        filter_genres: 'Вибрати жанри',
        filter_genres_ph: 'За якими жанрами шукати',
        filter_exclude_genres: 'Виключити жанри',
        filter_exclude_genres_ph: 'Які жанри виключити',
        filter_type: 'Тип аніме',
        filter_type_ph: 'Який тип аніме шукати',
        filter_status: 'Статус аніме',
        filter_year: 'Рік',
        filter_year_from: 'від',
        filter_year_to: 'до',
        filter_season: 'Сезон',
        filter_episodes: 'Кількість серій',
        filter_ep_tooltip: 'В онгоїнгах та анонсах не завжди вказано',
        filter_age: 'Віковий рейтинг',
        filter_sort: 'Сортувати за',
        filter_search: 'Шукати',
        filter_random: 'Випадкове аніме за фільтром',
        filter_expand: 'Розширити фільтр',
        filter_asc: 'За зростанням',
        filter_desc: 'За спаданням',
        sort_relevance: 'Релевантністю',
        sort_title_az: 'Назвою (А-Я)',
        sort_year: 'Датою виходу',
        sort_rating: 'Рейтингом',
        sort_votes: 'Голосами',
        sort_views: 'Переглядами',
        footer_resources: 'НАШІ РЕСУРСИ',
        footer_site_info: 'ІНФОРМАЦІЯ ПРО САЙТ',
        footer_support: 'ТЕХНІЧНА ПІДТРИМКА ТА ДОПОМОГА',
        footer_disclaimer: 'Всі відео на сайті надані лише для ознайомлення.',
        footer_about: 'ПРО САЙТ',
        footer_rules: 'ПРАВИЛА САЙТУ',
        footer_privacy: 'ПОЛІТИКА КОНФІДЕНЦІЙНОСТІ',
        footer_rightholders: 'ІНФОРМАЦІЯ ДЛЯ ПРАВОВЛАСНИКІВ',
        footer_api: 'API САЙТУ',
        footer_chat: 'ЧАТ З ПІДТРИМКОЮ',
        footer_dev: 'КАНАЛ РОЗРОБКИ В ТЕЛЕГРАМ',
        footer_email: 'Пошта для співпраці:',
        footer_tg: 'Телеграм підтримки для користувачів:',
        footer_rights: 'Всі права захищені.',
        footer_new: 'Новий дизайн сайту',
        time_at: ' о ',
        ep_short: 'еп.',
        nothing_found: 'Нічого не знайдено.',
        nothing_found_shrug: 'Нічого не знайдено ¯\\_(ツ)_/¯',
        search_try_query: 'Спробуйте змінити пошуковий запит',
        search_try_filter: 'Спробуйте змінити фільтр.',
        search_or: 'або',
        search_google: 'загуглити',
        search_google_suffix: ' аніме',
        search_live_nothing: 'Нічого не знайдено. Спробуйте вказати іншу назву.',
        search_open_all: 'Відкрити всі результати',
        loading: 'Завантаження',
        show_more: 'Показати ще',
        tg_support: "//YummyAnime_support.t.me/"
    },
} as const;

type Lang = keyof typeof strings;
type Key = keyof typeof strings['ru'];

export function tjs(key: Key): string {
    const lang = LANG as Lang;
    return (strings[lang]?.[key] ?? strings['ru'][key]) as string;
}
